import { locales, setLocale, type SupportedLocale } from '@yorukiri/i18n';
import { Select } from '@yorukiri/ui';
import { useTranslation } from '@yorukiri/i18n';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage?.split('-')[0] ?? 'en') as SupportedLocale;
  return (
    <Select
      size="sm"
      value={current}
      onValueChange={(v) => setLocale(v as SupportedLocale)}
      align="start"
      triggerStyle={{ minHeight: 26, fontSize: 11.5 }}
      options={locales.map((l) => ({
        value: l.code,
        label: l.nativeLabel,
        description: l.label !== l.nativeLabel ? l.label : undefined,
      }))}
    />
  );
}
